import _defineProperty from "/builds/kanguroo/kanguroo-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useRef, useEffect, createElement } from 'react';
import { BrowserQRCodeReader } from '@zxing/browser';
var isMediaDevicesSupported = function isMediaDevicesSupported() {
  var isMediaDevicesSupported = typeof navigator !== 'undefined' && !!navigator.mediaDevices;
  if (!isMediaDevicesSupported) {
    console.warn("[ReactQrReader]: MediaDevices API has no support for your browser. You can fix this by running \"npm i webrtc-adapter\"");
  }
  return isMediaDevicesSupported;
};
var isValidType = function isValidType(value, name, type) {
  var isValid = typeof value === type;
  if (!isValid) {
    console.warn("[ReactQrReader]: Expected \"".concat(name, "\" to be a of type \"").concat(type, "\"."));
  }
  return isValid;
};
var useQrReader = function useQrReader(_ref) {
  var delayBetweenScanAttempts = _ref.scanDelay,
    video = _ref.constraints,
    onResult = _ref.onResult,
    videoId = _ref.videoId;
  var controlsRef = useRef(null);
  useEffect(function () {
    var codeReader = new BrowserQRCodeReader(null, {
      delayBetweenScanAttempts: delayBetweenScanAttempts
    });
    if (!isMediaDevicesSupported() && isValidType(onResult, 'onResult', 'function')) {
      var message = 'MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"';
      onResult(null, new Error(message), codeReader);
    }
    if (isValidType(video, 'constraints', 'object')) {
      codeReader.decodeFromConstraints({
        video: video
      }, videoId, function (result, error) {
        if (isValidType(onResult, 'onResult', 'function')) {
          onResult(result, error, codeReader);
        }
      }).then(function (controls) {
        return controlsRef.current = controls;
      }).catch(function (error) {
        if (isValidType(onResult, 'onResult', 'function')) {
          onResult(null, error, codeReader);
        }
      });
    }
    return function () {
      var _controlsRef$current;
      (_controlsRef$current = controlsRef.current) === null || _controlsRef$current === void 0 ? void 0 : _controlsRef$current.stop();
    };
  }, []);
};
var styles = {
  container: {
    width: '100%',
    paddingTop: '100%',
    overflow: 'hidden',
    position: 'relative'
  },
  video: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    overflow: 'hidden',
    position: 'absolute',
    transform: undefined
  }
};
var QrReader = function QrReader(_ref2) {
  var videoContainerStyle = _ref2.videoContainerStyle,
    containerStyle = _ref2.containerStyle,
    videoStyle = _ref2.videoStyle,
    constraints = _ref2.constraints,
    ViewFinder = _ref2.ViewFinder,
    scanDelay = _ref2.scanDelay,
    className = _ref2.className,
    onResult = _ref2.onResult,
    videoId = _ref2.videoId;
  useQrReader({
    constraints: constraints,
    scanDelay: scanDelay,
    onResult: onResult,
    videoId: videoId
  });
  return /*#__PURE__*/createElement("section", {
    className: className,
    style: containerStyle
  }, /*#__PURE__*/createElement("div", {
    style: _objectSpread(_objectSpread({}, styles.container), videoContainerStyle)
  }, !!ViewFinder && /*#__PURE__*/createElement(ViewFinder, null), /*#__PURE__*/createElement("video", {
    muted: true,
    id: videoId,
    style: _objectSpread(_objectSpread(_objectSpread({}, styles.video), videoStyle), {}, {
      transform: (constraints === null || constraints === void 0 ? void 0 : constraints.facingMode) === 'user' && 'scaleX(-1)'
    })
  })));
};
QrReader.displayName = 'QrReader';
QrReader.defaultProps = {
  constraints: {
    facingMode: 'user'
  },
  videoId: 'video',
  scanDelay: 500
};
export { QrReader, useQrReader };